export default __webpack_public_path__ + "img/etisalat.6d2509bf.png";